export const OcplcKmatLockingQuery = `query OcplcKmatLockingQuery($kmatId: [String!], $isAdmin: Boolean!, $loginUserEmailId: String!, $lastModifiedTime: String!, $status: String!, $isBack: Boolean!)
 {
    ocplcKmatLocking(filter: {
            kmatId: $kmatId,
            isAdmin: $isAdmin
            loginUserEmailId: $loginUserEmailId,
            lastModifiedTime: $lastModifiedTime
            status: $status,
            isBack: $isBack,
        }) {
        response
        isError
    }
}
`;
